<template>
<div class="goodOrBad">
  <GoodView :goodOrBad="goodOrBad"/>
  <BadView :goodOrBad="goodOrBad"/>
</div>
</template>
<script>
import GoodView from './GoodView.vue'
import BadView from './BadView.vue'

export default {
  name: 'goodOrBad',
  components:{GoodView,BadView},
  data:()=>({}),
  props:{
    goodOrBad: {type: Array}
  },
  methods:{},
  created(){},
  mounted(){},
  watch:{}
}
</script>
<style lang="sass" scoped>
.goodOrBad
  padding: 20px
  display: grid
  grid-gap: 20px
</style>
